var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "center_skeleton" },
    [
      _c("v-progress-linear", {
        staticClass: "bar_data",
        attrs: { indeterminate: "", color: "#00b0ff" },
      }),
      _c(
        "v-row",
        [
          _c(
            "v-col",
            { attrs: { cols: "12", md: "6" } },
            [_c("v-skeleton-loader", { attrs: { type: "image" } })],
            1
          ),
          _c(
            "v-col",
            { attrs: { cols: "12", md: "6" } },
            [
              _c("v-skeleton-loader", {
                staticClass: "table_box_skeleton",
                attrs: { type: "table" },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }